export function countWords(text: unknown): number {
  if (!text || typeof text !== 'string') return 0;
  const trimmed = text.trim();
  return trimmed === '' ? 0 : trimmed.split(/\s+/).length;
}
